import api from 'Cloud/Application/api';
import { logger } from 'lib/logger';
import { GetFamilyFolderListCall } from 'reactApp/api/family/GetFamilyFolderListCall';
import { IS_FAMILY_USER } from 'reactApp/appHelpers/configHelpers';
import { familyFoldersInShared } from 'reactApp/appHelpers/featuresHelpers/features/familyFoldersInShared';
import { isUserWithFamily } from 'reactApp/modules/family/family.selectors';
import { loadSharedLinksRequest, loadSharedLinksStartRequest, loadSharedLinksSuccess } from 'reactApp/modules/shared/shared.module';
import { ESortOder } from 'reactApp/modules/sort/sort.types';
import { put, select, takeEvery } from 'redux-saga/effects';

const getFolderListCall = () => new GetFamilyFolderListCall().makeRequest({ order: ESortOder.desc });

function* loadSharedLinks() {
    try {
        yield put(loadSharedLinksRequest());

        let { list } = yield Promise.resolve(api.folder.shared.links());

        const withFamily = yield select(isUserWithFamily);
        /**
         * CLOUD-4650: Заменяем поле kind для семейных папок
         */
        if (!familyFoldersInShared && (withFamily || IS_FAMILY_USER)) {
            const familyList = (yield getFolderListCall())?.data?.list;
            if (familyList) {
                list = list.map((item) => {
                    const isFamilyFolder = !!familyList.find((familyItem) => familyItem.home.toLowerCase() === item.home.toLowerCase());
                    if (isFamilyFolder) {
                        item = { ...item, kind: 'family' };
                    }
                    return item;
                });
            }
        }

        yield put(
            loadSharedLinksSuccess({
                list: [...list],
            })
        );
    } catch (error) {
        logger.error(error);
    }
}

export function* watchShared() {
    yield takeEvery(loadSharedLinksStartRequest.toString(), loadSharedLinks);
}
